export default "__VITE_ASSET__NLaQcb_e__"